/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React from 'react';
// import styles from "./DetailsSection.module.css";
// import styles from "./ddt.module.css"
import styles from '../../styles/profile/profilecont.module.css';
import InputField from '../controlVariations/InputField';
import save from '../../assets/profile/Save.png';

interface Field {
	label: string;
	value: string;
	placeholder?: string;
	type?: string;
	iconSrc?: string; // <-- add this line
	error?: string; // ✅ ADD THIS
}

interface DetailsSectionProps {
	sectionTitle: string;
	iconSrc: string;
	fields: Field[];
	isEditing: boolean;
	onSaveClick?: () => void; // <-- NEW prop for save button click
	showSave?: boolean; // <-- NEW prop to control visibility
	onFieldChange?: (index: number, value: string) => void; // ✅ add this
}

const DetailsSection2: React.FC<DetailsSectionProps> = ({
	sectionTitle,
	iconSrc,
	fields,
	isEditing,
	onSaveClick,
	showSave = false,
	onFieldChange,
}) => {
	return (
		<div className={styles.detailsSection}>
			{/* Section Header */}
			<div className={styles.header}>
				<div className={styles.head}>
					<div className={styles.iconCont}>
						{' '}
						<img
							src={iconSrc}
							alt={sectionTitle}
							className={styles.icon}
						/>
					</div>
					<h3 className={styles.title}>{sectionTitle}</h3>
				</div>

				{/* Save button (top right corner like Figma) */}
				{showSave && (
					<button className={styles.saveButton} onClick={onSaveClick}>
						<img
							src={save}
							alt="Save"
							className={styles.saveIcon}
						/>
					</button>
				)}
			</div>

			{/* Fields */}
			<div className={styles.fieldsContainer}>
				{fields.map((field, index) => (
					<div key={index} className={styles.fieldRow}>
						<label className={styles.label}>{field.label}</label>
						{isEditing ? (
							// <InputField
							//     type={field.type || 'text'}
							//     placeholder={field.placeholder}
							//     value={field.value}
							//     onChange={(
							//         e: React.ChangeEvent<HTMLInputElement>
							//     ) => onFieldChange?.(index, e.target.value)}
							// />
							<>
								<InputField
									type={field.type || 'text'}
									placeholder={field.placeholder}
									value={field.value}
									onChange={(
										e: React.ChangeEvent<HTMLInputElement>
									) => onFieldChange?.(index, e.target.value)}
								/>

								{/* ✅ ERROR MESSAGE */}
								{field.error && (
									<p className={styles.errorText}>
										{field.error}
									</p>
								)}
							</>
						) : (
							<div className={styles.value}>
								{field.iconSrc && (
									<img
										src={field.iconSrc}
										alt={`${field.label} icon`}
										className={styles.valueIcon}
									/>
								)}
								<span>{field.value}</span>
							</div>
						)}
					</div>
				))}
			</div>
		</div>
	);
};

export default DetailsSection2;
